import ajax from "@/lib/ajax";

const URLs = {
    MODULE_EDIT: "/xiaoyue-operation/global/module/edit", // 模块配置
    MODULE_GET: "/xiaoyue-operation/global/module/list" // 模块配置
};

// 获取模块配置接口
export async function queryModules() {
    let ret = null;
    try {
        const resp = await ajax.get(URLs.MODULE_GET, {});
        ret = {
            robot: (resp.robot || []).map(item => item.id),
            ticket: (resp.ticket || []).map(item => item.id),
            im: (resp.im || []).map(item => item.id),
            titan: (resp.titan || []).map(item => item.id),
            uo: (resp.uo || []).map(item => item.id)
        };
    } catch (err) {
        // TODO
    }
    return ret;
}

// 设置单模块权限
export async function setModule(moduleName, permits) {
    const request = {
        classify: moduleName,
        content: permits.join(",")
    };

    try {
        await ajax.post(URLs.MODULE_EDIT, request);
    } catch (err) {
        // TODO
    }
}
